import { AxiosError } from 'axios';
import { UseMutationResult, useMutation } from 'react-query';
import { api } from '../api';
import { useUserContext } from '../providers/UserProvider';
import queryClient from '../query-client';
import { PatchResponseBody } from '../types/api-response';
import { User } from '../types/user';

export type UpdateUsersRequest = {
    id: string;
    fields: Partial<User>;
}[];

async function updateUsers(request: UpdateUsersRequest): Promise<PatchResponseBody<User>> {
    const { data } = await api.patch(`/users`, request);
    return data;
}

export function useUpdateUsers(): UseMutationResult<PatchResponseBody<User>, AxiosError, UpdateUsersRequest, unknown> {
    const { id } = useUserContext();
    return useMutation(updateUsers, {
        onSettled: () => {
            queryClient.invalidateQueries(['users']);
            queryClient.invalidateQueries(['user', id]);
            queryClient.invalidateQueries(['current-user']);
            queryClient.invalidateQueries(['workpapers']);
        },
    });
}
